import type { GQL_ID, NestedFilter } from '@@partner:types:graphql'

import React, { useState, useEffect } from 'react'
import { CheckPicker } from 'rsuite'
import { useFetchAllBannerTypes } from '@@partner:graphql/query/banners/allBannerTypes.gql'
import { renderLazyPickerMenu } from '@components/common/pickers'
export interface CategoriesFilterrProps {
  skipIds?: GQL_ID[]
  value: GQL_ID[]
  onChange: (value: GQL_ID[]) => void
  multiple?: boolean
}

export interface ItemDataType {
  label: string
  value: GQL_ID
}

const defaultGroupFilter: NestedFilter = {
  fields: [ 'name' ],
  op: 'unwrap'
}

export default function BannerTypesFilter ({
  skipIds = [],
  value,
  onChange,
  multiple = true
}: CategoriesFilterrProps) {
  const [ state, setState ] = useState<ItemDataType[]>([])
  const [ filter, setFilter ] = useState<NestedFilter>(defaultGroupFilter)

  const handleSearchByName = (text: string) => {
    setFilter({
      or: [
        {
          fields: [ 'name' ],
          op: 'starts_with',
          value: [ text ]
        }
      ]
    })
  }

  const { data, loading, error } = useFetchAllBannerTypes({
    filter: filter,
    pager: {
      page: 1,
      limit: 100
    },
    sort: {
      fieldName: 'updated_at',
      direction: 1
    }
  })

  useEffect(() => {
    if (!loading) {
      setState(data?.allBannerTypes.edges.map(banner => ({
        label: banner.label || banner.code,
        value: banner.id
      })) ?? [])
    }
  }, [ data?.allBannerTypes.edges, loading ])


  const handleChange = (category: ItemDataType) => {
    if (!multiple) {
      onChange([ category.value ])
    }
    else {
      if (category.value && value?.includes(category.value)) {
        onChange(value.filter(cat => cat !== category.value))
      }
      else if (category.value) {
        onChange([
          ...value,
          category.value
        ])
      }
    }
  }

  const handleClear = () => {
    onChange([])
  }

  return (
    <div>
      {/* {JSON.stringify(data)} */}
      <CheckPicker
        placeholder={'Выберите типы баннеров'}
        data={state}
        value={value}
        onChange={onChange}
        onClean={handleClear}
        onSearch={handleSearchByName}
        renderMenu={renderLazyPickerMenu(loading, data)}
      />
    </div>
  )
}
